// components/Logo.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React from 'react';
import Image from 'material-ui-image';
import logo from '../assets/icons/basic.png'
import logo_white from '../assets/icons/basic.png'
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => 
  createStyles({
    logo: {
      width: 60,
      // height: 200,
      marginBottom: theme.spacing(1)
    },
    bigLogoContainer: {
      width: '30vw',
      minWidth: 240,
      marginBottom: theme.spacing(2)
    },
    centerLogoContainer: {
      width: 70,
      minWidth: 70,
      backgroundColor: 'none'
    },
    menuLogo: {
      width: 70
    },
    logoMain: {
      width: 90,
    }
  })
)

export function TextLogo() {
  const classes = useStyles()
  return (
    <img
      alt="logo"
      className={classes.logo}
      src={ logo }
    />
  )
}

export function TextLogoLight() {
  const classes = useStyles()
  return (
    <img
      alt="logo"
      className={classes.menuLogo}
      src={ logo_white }
    />
  )
}

export function BigTextLogo() {
  const classes = useStyles()
  return (
    <div className={classes.bigLogoContainer}>
      <TextLogo/>
    </div>
  )
}

export function MainLogo({ light }) {
  const classes = useStyles()
  return (
    <div className={classes.centerLogoContainer}>
      <img
        alt="logo"
        className={classes.logoMain}
        src={ logo }
      />
    </div>
  )
}

export function MenuLogo({ light }) {
  const classes = useStyles()
  return (
    <div className={classes.menuLogoContainer}>
      { light ? <TextLogoLight/> : <TextLogo/> }
    </div>
  )
}